import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21882a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-tip" }
const _hoisted_2 = { class: "content-tip-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-tip-top-bg" }, null, -1))
const _hoisted_4 = { class: "content-tip-top-text" }
const _hoisted_5 = { class: "content-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { onMounted, ref } from 'vue';
import { selfAdaption, useDataAssembly } from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-1',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
let _data = useDataAssembly(props.tableHeaderList, props.tableDataList);
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "patient-sex",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_data).tipData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content-tip-item",
              key: index,
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
            }, [
              _createElementVNode("div", {
                class: "content-tip-top",
                style: _normalizeStyle({ marginTop: (index + 1) / 2 != 0 ? '3px' : '0px' })
              }, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item2, index2) => {
                      return (_openBlock(), _createElementBlock("div", { key: index2 }, _toDisplayString(item2.label) + ":" + _toDisplayString(item2.value), 1))
                    }), 128))
                  ])
                ])
              ], 4)
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})